import { render, staticRenderFns } from "./Websites.vue?vue&type=template&id=422af8fc&scoped=true&"
import script from "./Websites.vue?vue&type=script&lang=js&"
export * from "./Websites.vue?vue&type=script&lang=js&"
import style0 from "./Websites.vue?vue&type=style&index=0&id=422af8fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422af8fc",
  null
  
)

export default component.exports